import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * FAQHead — shared SEO head component for FAQ pages.
 * Renders <title>, meta description, canonical URL, and JSON-LD structured data.
 */
const FAQHead = ({ title, description, keywords, canonicalUrl, jsonLd }) => {
    const blocks = !jsonLd ? [] : (Array.isArray(jsonLd) ? jsonLd : [jsonLd]);
    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
            {blocks.map((block, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(block)}
                </script>
            ))}
        </Helmet>
    );
};

export default FAQHead;
